document.addEventListener("DOMContentLoaded", () => {});
// Migración: lógica de navegación de tabs adaptada
document.addEventListener('DOMContentLoaded', function() {
	const tabsContainers = document.querySelectorAll('.tabs-block');
	tabsContainers.forEach(initializeTabs);
});

function initializeTabs(tabsContainer) {
	const tabsNavigation = tabsContainer.querySelector('.tabs-navigation');
	const tabsContent = tabsContainer.querySelector('.tabs-content');
	const tabPanels = tabsContent.querySelectorAll('.tab-block');

	tabsNavigation.innerHTML = '';
	tabPanels.forEach((tabPanel, index) => {
		const tabButton = document.createElement('button');
		tabButton.className = 'tab-button';
		tabButton.textContent = tabPanel.dataset.tabTitle || `Tab ${index + 1}`;
		tabButton.setAttribute('data-tab-index', index);
		tabButton.setAttribute('type', 'button');
		tabButton.addEventListener('click', (event) => {
			event.preventDefault();
			showTab(tabsContainer, index);
			event.currentTarget.blur();
		});
		tabsNavigation.appendChild(tabButton);
		tabPanel.classList.add('tab-panel');
		if (index === 0) {
			tabPanel.classList.add('active');
			tabButton.classList.add('active');
		}
	});
}

function showTab(tabsContainer, activeIndex) {
	const tabButtons = tabsContainer.querySelectorAll('.tab-button');
	const tabPanels = tabsContainer.querySelectorAll('.tab-panel');
	tabButtons.forEach(button => button.classList.remove('active'));
	tabPanels.forEach(panel => panel.classList.remove('active'));
	if (tabButtons[activeIndex]) tabButtons[activeIndex].classList.add('active');
	if (tabPanels[activeIndex]) tabPanels[activeIndex].classList.add('active');

	// Cuando cambia el tab la altura de la página puede variar.
	// Refrescamos ScrollTrigger para que recalcule posiciones de todos los bloques.
	if (typeof ScrollTrigger !== 'undefined') {
		ScrollTrigger.refresh();
	}
}
